<template>
  <div id="app">
  
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
*{
  margin: 0;
  padding: 0;
  list-style: none;
}
ul li{
  list-style: none;
}
body,html{
  width: 100%;
  height: 100%;
}
.highlight {
    color: #ffbb22 !important;
    position: relative;
}
.highlight:hover .tip_box{
    display: block;
}
.tip_box{
    display: none;
    position: absolute;
    left: 0;
    transform: translateX(-20%);
    top: 25px;
    /* bottom: -45px; */
    border-radius: 5px;
    color: #ffbb22;
    background-color: #fefefe;
    width: 400px;
    z-index: 1002;
    padding: 10px;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue